import { IShipmentStopTypes } from 'types/graphqlTypes'
import * as yup from 'yup'
import { ONE_OF_MESSAGE, REQUIRED_MESSAGE } from '../../constants'
import { AppointmentSchemaObject } from './AppointmentSchema'
import { ShipperFacilitySchemaObject } from './ShipperFacilitySchema'

const STOP_TYPE_OPTIONS = Object.values(IShipmentStopTypes)

export const StopSchemaObject = {
  /**
   * @example 'pickup'
   */
  stopType: yup
    .mixed<IShipmentStopTypes>()
    .oneOf(STOP_TYPE_OPTIONS, `${ONE_OF_MESSAGE}: ${STOP_TYPE_OPTIONS.join(', ')}`)
    .required(REQUIRED_MESSAGE),
  /**
   * @example 1
   */
  stopSequence: yup.number().required(REQUIRED_MESSAGE),
  /**
   * Includes: shipperFacility
   */
  ...ShipperFacilitySchemaObject,
  /**
   * Includes: appointmentType, startAtDate, startAtTime, endAtDate, endAtTime
   */
  ...AppointmentSchemaObject,
  /**
   * @example false
   */
  dropTrailer: yup.boolean().default(false).notRequired(),
  /**
   * @example 'Special instructions for the stop'
   */
  specialInstruction: yup.string().notRequired(),
  /**
   * @example 4500
   */
  weight: yup.number().nullable().notRequired(),
  /**
   * @example 22
   */
  palletCount: yup.number().nullable().notRequired(),
  /**
   * @example 'wine'
   */
  genericCommodityId: yup.string().notRequired(),
  /**
   * @example 'This is a description of the commodity'
   */
  commodity: yup.string().required(REQUIRED_MESSAGE),
  /**
   * @example '1234'
   */
  billOfLadingReference: yup.string().notRequired(),
  /**
   * @example '5678'
   */
  poReference: yup.string().notRequired(),
  /**
   * @example '123'
   */
  vendorId: yup.string().nullable().notRequired(),
}

export const StopSchema = yup.object(StopSchemaObject)

export type TStopSchema = yup.InferType<typeof StopSchema>
